<template>
  <div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="nodeName" label="审核节点"></el-table-column>
      <el-table-column prop="apprUserName" label="审核人"></el-table-column>
      <el-table-column prop="apprStatusName" label="审核状态"></el-table-column>
      <el-table-column prop="apprTime" label="审核时间">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.apprTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="apprOpinion" label="审核意见"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getProtocolLogListByCond } from "@/util/api.js";

export default {
  props: {
    protocolId: {
      type: String
    }
  },
  data () {
    return {
      procInstId: null,
      tableData: [],
      workflowProcessUrl: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      if (this.protocolId) {
        getProtocolLogListByCond({
          searchCond: {
            protocolId: this.protocolId
          }
        }).then(res => {
          if (res.msgCode == 200) {
            this.tableData = res.responseData.modelData;
          }
        });
      }
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.workflow-process {
  width: 100%;
  height: 380px;
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/protocol/view/ProtocolHistory.vue